import gql from 'graphql-tag';

export const CREATE_EQUIPMENT = gql`
  mutation CreateEquipment($input: UpsertEquipmentInput!) {
    upsertEquipment(input: $input) {
      id
    }
  }
`;
